import { Link } from 'react-router';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { url } from '@app/utils/constants';
import { StyledButton } from '@app/components/button/Button';
import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import type { UseFormReset } from 'react-hook-form';
import { TextField } from '@app/components/form-fields/TextField';

const formSchema = z.object({
    email: z.string().trim().min(1, 'Email is required'),
    password: z.string().trim().min(1, 'Password is required'),
});

export type LoginFormValues = z.infer<typeof formSchema>;

export type LoginFormProps = {
    onSubmit: (
        data: LoginFormValues,
        reset?: UseFormReset<LoginFormValues>
    ) => void;
};

export const LoginForm = ({ onSubmit }: LoginFormProps) => {
    const {
        handleSubmit,
        control,
        reset,
        formState: { isValid, isSubmitting },
    } = useForm<LoginFormValues>({
        mode: 'all',
        resolver: zodResolver(formSchema),
        defaultValues: {
            email: '',
            password: '',
        },
    });

    return (
        <form onSubmit={handleSubmit((values) => onSubmit(values, reset))}>
            <div className='form-fields-wrapper'>
                <Controller
                    name='email'
                    control={control}
                    render={({ field, fieldState }) => (
                        <TextField
                            fieldState={fieldState}
                            {...field}
                            label={
                                <span className='label-with-action'>
                                    <span>Username</span>
                                    {/* <small className='action'>
                                        <Link
                                            to={url.account.forgotAccount}
                                            className='text-blue'
                                        >
                                            Forgot Email?
                                        </Link>
                                    </small> */}
                                </span>
                            }
                            type='text'
                            placeholder='Enter your Username'
                        />
                    )}
                />
                <Controller
                    name='password'
                    control={control}
                    render={({ field, fieldState }) => (
                        <TextField
                            fieldState={fieldState}
                            {...field}
                            label={
                                <span className='label-with-action'>
                                    <span>Password</span>
                                    <small className='action'>
                                        <Link
                                            to={url.account.forgotPassword}
                                            className='text-blue'
                                        >
                                            Forgot Password?
                                        </Link>
                                    </small>
                                </span>
                            }
                            type='password'
                            placeholder='Enter your Password'
                            showViewPasswordIcon
                        />
                    )}
                />
            </div>
            <StyledButtonGroup justify='flex-end'>
                <StyledButton
                    htmlType='submit'
                    type='primary'
                    size='large'
                    block
                    disabled={!isValid}
                    loading={isSubmitting}
                >
                    Submit
                </StyledButton>
            </StyledButtonGroup>
        </form>
    );
};
